/* Produktfinder-Attribution (Farben Löwe) — schreibt pf_session als Cart-Attribut,
 * damit jede Bestellung der Session zuverlässig dem Produktfinder zugeordnet wird
 * (note_attribute-Weg im Webhook). Rein additiv, gekapselt. Claude 2026-05-30. */
(function () {
  "use strict";
  try {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get("pf_session");
    if (fromUrl) {
      try { localStorage.setItem("pf_session", fromUrl); } catch (e) {}
      try { document.cookie = "pf_session=" + encodeURIComponent(fromUrl) + ";path=/;max-age=" + (60 * 60 * 24 * 30) + ";SameSite=Lax"; } catch (e) {}
    }
    var stored = fromUrl;
    if (!stored) { try { stored = localStorage.getItem("pf_session"); } catch (e) {} }
    if (!stored) { var m = document.cookie.match(/(?:^|;\s*)pf_session=([^;]+)/); if (m) stored = decodeURIComponent(m[1]); }
    if (!stored) return;

    // Cart-Attribut nur setzen, wenn noch nicht (oder abweichend) gesetzt — vermeidet unnötige Requests.
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes.pf_session === stored) return;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: { pf_session: stored } })
        });
      })
      .catch(function () {});
  } catch (e) {}
})();

/* 23.10.2026: Der Block „Produktfinder-Locale-Links“ (schrieb alle Links auf den Finder-Host und auf die Lantern-App auf den Finder mit ?lang=<Sprache> um) ist weg: Jeder Link zeigt selbst auf die Seite des Marktes (/pages/produktfinder, Shopify liefert den uebersetzten Handle), Plan reviews/2026-10-20-produktfinder-landesdomain-plan.md. */

/* Bilder je Sprache: bis 29.09.2026 tauschte hier ein Skript deutsche Bilder gegen die Fassung aus einer Tabelle von
 * new-era.cloud. Seitenbilder uebersetzt jetzt Shopify selbst (Translate & Adapt, Bildfelder je Sprache), Produktbilder
 * waehlt das Theme (snippets/fl-loc-bild.liquid, wie Hamburger Lack-Profi). Der Shop haengt dafuer nicht mehr an
 * unserem Server (Finn 29.09.2026). */

/* 18.10.2026 entfernt: FL-APO-WATCHDOG (Claude 2026-06-11). Er lud Produktseiten nach 9 s selbst neu, wenn window.color ein Objekt war und kein
   Select mit mehr als 50 Optionen da war (gedacht als Heilung, wenn MageWorx nicht laedt). Das traf aber auch jedes Produkt ohne RAL-Feld:
   12 von 31 gemessenen Produktseiten (jede 5. von 154) wurden nach 9,98 bis 12,1 s neu geladen, Auswahl und Scrollstand weg
   (Ladeanalyse 18.10.2026). Die Attribution oben (pf_session) haengt nicht daran. */
